// extracted by mini-css-extract-plugin
export default {"spinner":"MessagesPerBuPage_spinner__EnhqA"};